import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Menu, LogOut, User, ChevronDown } from "lucide-react";

export default function Topbar({ onToggleSidebar }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button className="topbar-toggle" onClick={onToggleSidebar}>
          <Menu size={22} />
        </button>
        <h1 className="topbar-title">Yönetim Paneli</h1>
      </div>

      <div className="topbar-right" ref={dropdownRef}>
        <div className="topbar-profile" onClick={() => setDropdownOpen(!dropdownOpen)}>
          <div className="profile-avatar">
            <User size={18} />
          </div>
          <span className="profile-name">Admin</span>
          <ChevronDown size={16} className={`profile-arrow ${dropdownOpen ? "rotated" : ""}`} />
        </div>

        {dropdownOpen && (
          <div className="topbar-dropdown">
            <button
              className="dropdown-item"
              onClick={() => { navigate("/change-password"); setDropdownOpen(false); }}
            >
              <User size={16} />
              Şifre Değiştir
            </button>
            <div className="dropdown-divider" />
            <button className="dropdown-item logout" onClick={handleLogout}>
              <LogOut size={16} />
              Çıkış Yap
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
